import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Nuevas_normasComponent = /** @class */ (function () {
    function Nuevas_normasComponent(_formService) {
        this._formService = _formService;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            nuevas_normas: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("nuevas_normas"))) {
            localStorage.setItem("nuevas_normas", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("nuevas_normas"));
            this.form.controls['nuevas_normas'].setValue(this.rows[0] ? this.rows[0].nuevas_normas : '');
        }
    }
    Nuevas_normasComponent.prototype.add_nuevas_normas = function () {
        localStorage.setItem("nuevas_normas", JSON.stringify([]));
        this.actualRow = localStorage.getItem("nuevas_normas");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            nuevas_normas: this.form.value.nuevas_normas,
        });
        localStorage.setItem("nuevas_normas", JSON.stringify(this.rows));
        //this.form.reset();
        //this.cip = JSON.parse(localStorage.getItem("cip"));
    };
    Nuevas_normasComponent.prototype.delete_nuevas_normas = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("nuevas_normas", JSON.stringify(this.rows));
            }
        }
    };
    return Nuevas_normasComponent;
}());
export { Nuevas_normasComponent };
